import { render, staticRenderFns } from "./SimpleMask.vue?vue&type=template&id=20e23cca&"
import script from "./SimpleMask.vue?vue&type=script&lang=js&"
export * from "./SimpleMask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports